import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Grid,
  Paper,
  Button,
  Divider,
  Avatar,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import '../../styles/Booking.scss';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import GroupIcon from '@mui/icons-material/Group';
import ReceiptIcon from '@mui/icons-material/Receipt';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import PercentIcon from '@mui/icons-material/Percent';
import {
  BOOKING_PASSENGER_DETAILS,
  SUCCESS_PAGE,
} from '../../component/common/Routes/AppRoutes';
import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { useDispatch, useSelector } from 'react-redux';
import {
  CUSTOMER_BOOKING_PASSENGER_DETAILS,
  CUSTOMER_SUCCESS_PAGE,
} from '../../component/common/Routes/CustomerRoutes';
import {
  VENDOR_BOOKING_PASSENGER_DETAILS,
  VENDOR_SUCCESS_PAGE,
} from '../../component/common/Routes/VendorRoutes';
import {
  addBookingRequest,
  resetBookingDetails,
} from '../../redux/Bookings/BookingAction';
import { toast, ToastContainer } from 'react-toastify';
import CustomButton from '../../component/ui/FormFields/Button';
import ControlledTextInputField from '../../component/ui/FormFields/ControlledTextInputField';
import { Controller, useForm } from 'react-hook-form';
import { fetchVendorDetailsRequest } from '../../redux/Vendors/actions/vendorActions';
import PaymentComponent from '../Payment/PaymentComponent';

const BookingInvoice = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector((state) => state.auth.user);

  const booking = useSelector((state) => state?.booking);
  const dispatch = useDispatch();
  const [showDiscount, setShowDiscount] = useState(false);
  const form1Value = location.state?.form1Value || {};
  const paymentUrl = booking?.data?.payment_url;
  const form2Value = location.state?.form2Value || {};
  const form3Value = location.state?.form3Value || {};
  const vendorDetailsState = useSelector(
    (state) => state.vendors.vendorDetails
  );
  useEffect(() => {}, []);
  const vendorDetails = vendorDetailsState?.data || {};

  const servicePlan =
    form1Value?.arrival_plan !== ''
      ? form1Value?.arrival_plan?.label
      : form1Value?.departure_plan !== ''
      ? form1Value?.departure_plan?.label
      : form1Value?.transit_plan !== ''
      ? form1Value?.transit_plan?.label
      : '-';

  const {
    control,
    formState: { errors },
    watch,
    setError,
    setValue,
    clearErrors,
  } = useForm({
    defaultValues: {
      discount: form3Value?.discount || 0,
      applyDiscount: form3Value?.applyDiscount || false,
      applyComplementary: form3Value?.applyComplementary || false,
    },
    mode: 'onChange',
  });
  useEffect(() => {
    dispatch(resetBookingDetails());
  }, []);
  const formValue = watch();
  const isError = Object.keys(errors).length > 0;
  const service = form1Value?.arrival_departure_type?.value || '';
  useEffect(() => {
    setShowDiscount(formValue?.applyDiscount || false);
  }, [formValue?.applyDiscount]);

  const successMessage = booking?.message;
  const errorMessage = booking?.error;
  const loading = booking?.loading;
  useEffect(() => {
    if (errorMessage) {
      toast.error('Failed to add booking', {
        position: 'top-center',
        autoClose: 3000,
        onClose: () => {
          dispatch(resetBookingDetails());
        },
      });
    }
  }, [errorMessage]);

  const SUCCESSURL = 'https://atithiairportseva.com/payment-success';
  const CANCELLEDURL = 'https://secure.ccavenue.com/cancelTransaction';

  useEffect(() => {
    if (paymentUrl) {
      window.location.href = paymentUrl;
    }
  }, [paymentUrl]);

  // useEffect(() => {
  //   const paymentUrls = paymentUrl;
  //   console.log('paymentUrls', paymentUrls);
  //   if (paymentUrls) {
  //     <PaymentComponent pnrNumber={pnrNumber} paymentUrl={paymentUrls} />;
  //   }
  // }, [paymentUrl]);

  const adultFamilyMember = form2Value?.family_members?.filter((adult) => {
    return adult?.age >= 12;
  });

  const infantFamilyMember = form2Value?.family_members?.filter((infant) => {
    return infant?.age < 2;
  });
  const childFamilyMember = form2Value?.family_members?.filter((child) => {
    return child?.age >= 2 && child?.age < 12;
  });
  const adultDiscount = adultFamilyMember?.[0]?.discount || 0;
  const childDiscount = childFamilyMember?.[0]?.discount || 0;
  const infantDiscount = infantFamilyMember?.[0]?.discount || 0;

  const adult = adultFamilyMember?.map((value) => {
    return {
      id: value?.id,
      passport_number: value?.aadhar_number || null,
      aadhar_number: value?.aadhar_number || null,
    };
  });
  const child = childFamilyMember?.map((value) => {
    return {
      id: value?.id,
      passport_number: value?.aadhar_number || null,
      aadhar_number: value?.aadhar_number || null,
    };
  });
  const infant = infantFamilyMember?.map((value) => {
    return {
      id: value?.id,
      passport_number: value?.aadhar_number || null,
      aadhar_number: value?.aadhar_number || null,
    };
  });

  const familyMember = [...(adult || []), ...(infant || []), ...(child || [])];
  const bookingValue = {
    customer_id:
      user.customer_id ||
      form2Value?.customer_id ||
      form1Value?.customerDetails?.id ||
      '-',
    first_name: ' ',
    last_name: ' ',
    email: '',
    display_name: '',
    phone: ' ',
    country_code: '',
    airport_id: form1Value?.airport?.value || '-',
    airport_type:
      form1Value?.service_type === 'Domestic'
        ? '1'
        : form1Value?.service_type === 'International'
        ? '2'
        : '3',

    service_type:
      form1Value?.arrival_departure_type?.value === 'Arrival'
        ? '1'
        : form1Value?.arrival_departure_type?.value === 'Departure'
        ? '2'
        : '3' || '-',
    service_id:
      form1Value?.arrival_plan?.value ||
      form1Value?.departure_plan?.value ||
      form1Value?.transit_plan?.value ||
      '-',
    number_of_adults: form2Value?.no_of_adult || '0',
    number_of_child: form2Value?.no_of_child || '0',
    number_of_infant: form2Value?.no_of_infant || '0',
    date_of_departure: form1Value?.departure_date || null,
    time_of_departure: form1Value?.departure_time || '-',
    departure_airlines: form1Value?.departure_airline || '-',
    arrival_from_city: form1Value?.arrival_city || '-',
    departure_from_city: form1Value?.departure_city || '-',
    departure_flight_number: form1Value?.departure_flight_number || '-',
    arrival_airlines: form1Value?.arrival_airline || '-',
    time_of_arrival: form1Value?.arrival_time || '-',
    date_of_arrival:
      form1Value?.arrival_date === ' ' ? '0' : form1Value?.arrival_date || null,
    total_passengers: form2Value?.total_passengers || '0',
    notes: form2Value?.notes || '-',
    address_id: form2Value.billing_address || '-',
    arrival_flight_number: form1Value?.arrival_flight_number || '-',
    number_of_service: form2Value?.no_of_service_required || '-',
    familymembers: familyMember || '-',
    proof_url: null,
    gender_type: 'M',
    vendor_gst_number: formValue.gst_number,
    discount: formValue?.discount || 0,
    booked_type: formValue?.applyComplementary ? 2 : 1,
    vendor_gst_number: formValue?.gst_number || '-',
    callBackUrl: 'http://localhost:3000/airports',
  };

  const submitBookingData = () => {
    console.log('bookingValue');
    dispatch(addBookingRequest(bookingValue));
  };

  const bookingData = [
    {
      icon: <GroupIcon className='passenger-icon' />,
      title: 'Passenger Details',
      fields: [
        { label: 'No. of Adults', value: form2Value.no_of_adult || 0 },
        { label: 'No. of Children', value: form2Value.no_of_child || 0 },
        { label: 'No. of Infants', value: form2Value.no_of_infant || 0 },
        { label: 'Total Passengers', value: form2Value.total_passengers || 0 },
      ],
    },
    {
      icon: <FlightTakeoffIcon className='service-icon' />,
      title: 'Service Details',

      fields: [
        { label: 'Service', value: servicePlan || '-' },
        { label: 'Arrival/Departure', value: service || '-' },
        { label: 'Service Type', value: form1Value.service_type.value || '-' },

        {
          label: 'Number of Services',
          value: form2Value.no_of_service_required || '0',
        },
      ],
    },
    {
      icon: <LocationOnIcon className='location-icon' />,
      title: 'Airport Details',
      fields:
        service === 'Arrival'
          ? [
              { label: 'Airport', value: form1Value.airport.label || '' },
              {
                label: 'Arrival Date & Time',

                value:
                  `${form1Value.arrival_date} - ${form1Value.arrival_time} ` ||
                  '',
              },
              {
                label: 'Arrival Flight Number',
                value: form1Value.arrival_flight_number || '',
              },
              {
                label: 'Arrival Airline',
                value: form1Value.arrival_airline || '',
              },
            ]
          : service === 'Departure'
          ? [
              { label: 'Airport', value: form1Value.airport.label || '-' },
              {
                label: 'Departure Date & Time',
                value:
                  `${form1Value.departure_date} - ${form1Value.departure_time} ` ||
                  '',
              },
              {
                label: 'Departure Flight Number',
                value: form1Value.departure_flight_number || '-',
              },
              {
                label: 'Departure Airline',
                value: form1Value.departure_airline || '-',
              },
            ]
          : [
              { label: 'Airport', value: form1Value.airport.label || '-' },
              {
                label: 'Arrival Date & Time',
                value:
                  `${form1Value.arrival_date} - ${form1Value.arrival_time} ` ||
                  '',
              },
              {
                label: 'Arrival Flight Number',
                value: form1Value.arrival_flight_number || '-',
              },
              {
                label: 'Arrival Airline',
                value: form1Value.arrival_airline || '-',
              },

              {
                label: 'Departure Date & Time',
                value:
                  `${form1Value.departure_date} - ${form1Value.departure_time} ` ||
                  '',
              },
              {
                label: 'Departure Flight Number',
                value: form1Value.departure_flight_number || '-',
              },
              {
                label: 'Departure Airline',
                value: form1Value.departure_airline || '-',
              },
            ],
    },
  ];

  const currencyFormatter = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 2,
  });

  const discountValue = formValue?.discount;
  const no_of_adult =
    adultDiscount > 0
      ? adultFamilyMember.length -
        (adultFamilyMember.length * adultDiscount) / 100
      : adultFamilyMember.length;
  const no_of_child =
    childDiscount > 0
      ? childFamilyMember.length -
        (childFamilyMember.length * childDiscount) / 100
      : childFamilyMember.length;
  const no_of_infant =
    infantDiscount > 0
      ? infantFamilyMember.length -
        (infantFamilyMember.length * infantDiscount) / 100
      : infantFamilyMember.length;
  const no_of_service = no_of_child + no_of_infant + no_of_adult;

  const servicePrice = form1Value.servicePlanPrice;

  const [discountPrice, setDiscountPrice] = useState(servicePrice);
  const vendorCommission =
    user?.user_type === 2
      ? -(
          parseFloat(no_of_service * servicePrice) *
          (vendorDetails?.discount / 100)
        ) || 0
      : 0;

  const [discountAmout, setDisountAmount] = useState(0);

  const discountedPrices = (customDiscountValue) => {
    if (discountValue > 100) {
      setError('discount', { message: 'Enter Between 0-100 %' });
    } else {
      const newDiscountValue =
        customDiscountValue >= 0 ? customDiscountValue : discountValue;
      clearErrors('discount');
      setDisountAmount(servicePrice * (newDiscountValue / 100));
      setDiscountPrice(servicePrice - servicePrice * (newDiscountValue / 100));
    }
  };

  const subTotal =
    parseFloat(no_of_service * servicePrice) -
      ((parseFloat(no_of_service * discountAmout) || 0) -
        (vendorCommission || 0)) || 0;

  const orderSummary = {
    totals: [
      form1Value?.servicePlanPrice && {
        label: 'Gross Amount',
        value: 0,
        formattedValue: currencyFormatter.format(
          parseFloat(form2Value?.total_passengers * servicePrice) || 0
        ),
      },

      adultFamilyMember?.length > 0 && {
        label: `Adult Discount(${adultDiscount}%)`,
        value: 0,
        formattedValue: currencyFormatter.format(
          -parseFloat(
            adultFamilyMember?.length * (adultDiscount / 100) * servicePrice
          ) || 0
        ),
      },
      childFamilyMember?.length > 0 && {
        label: `Child Discount(${childDiscount}%)`,
        value: 0,
        formattedValue: currencyFormatter?.format(
          -parseFloat(
            childFamilyMember?.length * (childDiscount / 100) * servicePrice
          ) || 0
        ),
      },
      infantFamilyMember?.length > 0 && {
        label: `Infant Discount(${infantDiscount}%)`,
        value: 0,
        formattedValue: currencyFormatter.format(
          -parseFloat(
            infantFamilyMember?.length * (infantDiscount / 100) * servicePrice
          ) || 0
        ),
      },
      vendorCommission !== 0 &&
        user?.user_type === 2 && {
          label: `Vendor Commission (${vendorDetails?.discount}%)`,
          value: 0,
          formattedValue: currencyFormatter.format(vendorCommission || 0),
        },
      formValue?.discount >= 0 &&
        user?.user_type !== 2 &&
        user?.user_type !== 3 && {
          label: `Booking Discount(${formValue?.discount}%)`,
          value: 0,
          formattedValue: currencyFormatter.format(
            -parseFloat(no_of_service * discountAmout) || 0
          ),
        },
      form1Value?.servicePlanPrice && {
        label: 'SubTotal',
        value: parseFloat(subTotal?.toFixed(2)),

        formattedValue: currencyFormatter.format(
          parseFloat(subTotal?.toFixed(2)) || 0
        ),
      },

      form1Value?.tax > 0 && {
        label: `TAX (${form1Value?.tax_percentage}%)`,
        value:
          parseFloat(subTotal?.toFixed(2)) *
            (parseFloat(form1Value.tax_percentage) / 100) || 0,
        formattedValue: currencyFormatter.format(
          parseFloat(subTotal?.toFixed(2)) *
            (parseFloat(form1Value.tax_percentage) / 100) || 0
        ),
      },
      form1Value?.sgst > 0 && {
        label: `SGST (${form1Value?.sgst_percentage}%)`,
        value:
          parseFloat(subTotal?.toFixed(2)) *
            (parseFloat(form1Value.sgst_percentage) / 100) || 0,
        formattedValue: currencyFormatter.format(
          parseFloat(subTotal?.toFixed(2)) *
            (parseFloat(form1Value.sgst_percentage) / 100) || 0
        ),
      },
      form1Value?.cgst > 0 && {
        label: `CGST (${form1Value?.cgst_percentage}%)`,
        value:
          parseFloat(subTotal?.toFixed(2)) *
            (parseFloat(form1Value.cgst_percentage) / 100) || 0,
        formattedValue: currencyFormatter.format(
          parseFloat(subTotal?.toFixed(2)) *
            (parseFloat(form1Value.cgst_percentage) / 100) || 0
        ),
      },
    ].filter(Boolean),
  }; // Ensure form1Value properties are valid numbers

  const totalAmount = orderSummary.totals.reduce(
    (sum, item) => sum + item.value,
    0
  );

  const formattedTotalAmount = currencyFormatter.format(totalAmount);

  const passengerInformation = {
    icon: <GroupIcon className='passenger-icon' />,
    title: 'Passengers Informations',
    fields: [
      {
        label: 'Adults',
        value: adultFamilyMember.map((adult) => {
          return {
            totals: [
              { label: 'First Name', value: adult?.first_name },
              { label: 'Last Name', value: adult?.last_name },
              { label: 'Age', value: adult?.age },
              {
                label: 'Mobile No',
                value: ` ${adult?.country_code}-${adult?.phone}`,
              },
              { label: 'Gender', value: adult?.gender_type },
              adult?.aadhar_number !== '' && {
                label: 'Aadhar No ',
                value: adult?.aadhar_number || '-',
              },
              adult?.passport_number !== '' && {
                label: 'Passport No ',
                value: adult?.passport_number || '-',
              },
              { label: 'Nationality', value: adult?.nationality || '-' },
            ],
          };
        }),
      },
      {
        label: 'Child',
        value: childFamilyMember.map((child) => {
          return {
            totals: [
              { label: 'First Name', value: child?.first_name },
              { label: 'Last Name', value: child?.last_name },
              { label: 'Age', value: child?.age },
              {
                label: 'Mobile No',
                value: `${child?.country_code}-${child?.phone}`,
              },
              { label: 'Gender', value: child?.gender_type },
              child?.aadhar_number !== '' && {
                label: 'Aadhar No ',
                value: child?.aadhar_number || '-',
              },
              child?.passport_number !== '' && {
                label: 'Passport No ',
                value: child?.passport_number || '-',
              },
              { label: 'Nationality', value: child?.nationality || '-' },
            ],
          };
        }),
      },
      {
        label: 'Infant',
        value: infantFamilyMember.map((infant) => {
          return {
            totals: [
              { label: 'First Name', value: infant?.first_name },
              { label: 'Last Name', value: infant?.last_name },
              { label: 'Age', value: infant?.age },
              {
                label: 'Mobile No',
                value: ` ${infant?.country_code}-${infant?.phone}`,
              },
              { label: 'Gender', value: infant?.gender_type },
              infant?.aadhar_number !== '' && {
                label: 'Aadhar No ',
                value: infant?.aadhar_number || '-',
              },
              infant?.passport_number !== '' && {
                label: 'Passport No ',
                value: infant?.passport_number || '-',
              },
              { label: 'Nationality', value: infant?.nationality || '-' },
            ],
          };
        }),
      },
    ],
  };

  // for automatic discount apply()
  useEffect(() => {
    discountedPrices();
    if (user?.user_type === 2) {
      dispatch(fetchVendorDetailsRequest(user?.vendor_id));
    }
  }, []);
  const updateDiscountValues = async (isChecked) => {
    if (isChecked) {
      setValue('applyComplementary', false);
    } else {
      setValue('applyDiscount', false);
      setValue('discount', 0);
      discountedPrices(0);
    }
  };

  const updateComplementaryValue = async (isChecked) => {
    if (isChecked) {
      setValue('applyDiscount', false);
      setValue('discount', 0);
      discountedPrices(0);
    } else {
      setValue('applyComplementary', false);
    }
  };

  // for select
  // Render fields dynamically
  const renderFields = (fields) =>
    fields.map((item, index) => (
      <Box key={index} className='label-value-container'>
        <Typography variant='body1' className='label-style'>
          {item.label}
        </Typography>
        <Typography variant='body1' className='value-style'>
          {item.value}
        </Typography>
      </Box>
    ));

  return (
    <>
      <ToastContainer />
      <Box className='booking-summary-body'>
        <Grid container spacing={4}>
          {/* Passenger Details (First Box) */}
          {bookingData[0] && (
            <Grid
              item
              xs={12} // Full width on small screens
              md={6} // Half-width on medium screens
              xl={4} // One-third width on 1440px and above
              key='row1-box1'
            >
              <Paper elevation={4} className='booking-summary-paper'>
                <Box className='booking-summary-content-box'>
                  <Box className='booking-heading-alignment'>
                    <Avatar className='booking-summary-avatar-style'>
                      {bookingData[0].icon}
                    </Avatar>
                    <Typography
                      variant='h6'
                      className='booking-summary-title-style'
                    >
                      {bookingData[0].title}
                    </Typography>
                  </Box>
                  <Divider
                    sx={{
                      margin: '10px 0',
                      borderColor: '#ddd',
                      width: '100%',
                    }}
                  />
                </Box>
                {renderFields(bookingData[0].fields)}
              </Paper>
            </Grid>
          )}
          {/* Booking Details (Second Box) */}
          {bookingData[1] && (
            <Grid
              item
              xs={12} // Full width on small screens
              md={6} // Half-width on medium screens
              xl={4} // One-third width on 1440px and above
              key='row1-box2'
            >
              <Paper elevation={4} className='booking-summary-paper'>
                <Box className='booking-summary-content-box'>
                  <Box className='booking-heading-alignment'>
                    <Avatar className='booking-summary-avatar-style'>
                      {bookingData[1].icon}
                    </Avatar>
                    <Typography
                      variant='h6'
                      className='booking-summary-title-style'
                    >
                      {bookingData[1].title}
                    </Typography>
                  </Box>
                  <Divider
                    sx={{
                      margin: '10px 0',
                      borderColor: '#ddd',
                      width: '100%',
                    }}
                  />
                </Box>
                {renderFields(bookingData[1].fields)}
              </Paper>
            </Grid>
          )}
          {/* Airport Details (Third Box) */}
          {bookingData[2] && (
            <Grid
              item
              xs={12} // Full width on small screens
              md={12} // Full width on medium screens
              xl={4} // One-third width on 1440px and above
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
              key='row1-box3'
            >
              <Paper
                elevation={4}
                className='booking-summary-paper'
                sx={{
                  width: '100%', // Ensure the Paper component spans the full width
                  maxWidth: '600px', // Optional: Limit the width for better design
                }}
              >
                <Box className='booking-summary-content-box'>
                  <Box className='booking-heading-alignment'>
                    <Avatar className='booking-summary-avatar-style'>
                      {bookingData[2].icon}
                    </Avatar>
                    <Typography
                      variant='h6'
                      className='booking-summary-title-style'
                    >
                      {bookingData[2].title}
                    </Typography>
                  </Box>
                  <Divider
                    sx={{
                      margin: '10px 0',
                      borderColor: '#ddd',
                      width: '100%',
                    }}
                  />
                </Box>
                <PerfectScrollbar
                  style={{
                    maxHeight: '170px',
                    overflowX: 'hidden',
                    paddingRight: '16px',
                  }}
                >
                  {renderFields(bookingData[2].fields)}
                </PerfectScrollbar>
              </Paper>
            </Grid>
          )}
          {/* Passenger Information */}
          <Grid item xs={12} md={6}>
            <Paper elevation={4} className='booking-summary-order-paper'>
              <Box className='booking-summary-order-box'>
                <Avatar className='booking-summary-order-avatar'>
                  {passengerInformation.icon}
                </Avatar>
                <Typography
                  variant='h6'
                  className='booking-summary-title-style'
                >
                  {passengerInformation.title}
                </Typography>
              </Box>
              <Divider className='booking-summary-divider' />

              {/* Passenger Categories */}
              <PerfectScrollbar
                style={{
                  maxHeight: '205px',
                  overflowX: 'hidden',
                  paddingRight: '16px',
                }}
              >
                {passengerInformation.fields.map((category, index) => (
                  <Box key={index} mb={2}>
                    {/* Category Label */}
                    <Typography
                      variant='subtitle1'
                      align='left'
                      className='booking-passenger-info-title-style'
                    >
                      {category.label}
                    </Typography>

                    {/* Render Passenger Information */}
                    {category.value.length > 0 ? (
                      category.value.map((info, i) => (
                        <Box key={i} mb={1}>
                          {renderFields(info.totals)}

                          <Divider className='booking-summary-divider' />
                        </Box>
                      ))
                    ) : (
                      <Typography
                        variant='body2'
                        align='left'
                        className='booking-passenger-info-detail-style'
                      >
                        No {category.label.toLowerCase()} information available.
                      </Typography>
                    )}
                  </Box>
                ))}
              </PerfectScrollbar>
            </Paper>
          </Grid>
          {/* Order Summary */}
          <Grid item xs={12} md={6}>
            <Paper elevation={4} className='booking-summary-order-paper'>
              <Box className='booking-summary-order-box'>
                <Avatar className='booking-summary-order-avatar'>
                  <ReceiptIcon className='booking-summary-receipticon' />
                </Avatar>
                <Typography
                  variant='h6'
                  className='booking-summary-title-style'
                >
                  Order Summary
                </Typography>
              </Box>
              <Divider className='booking-summary-divider' />
              <PerfectScrollbar
                style={{
                  maxHeight: '205px',
                  overflowX: 'hidden',
                  paddingRight: '16px',
                }}
              >
                {orderSummary.totals.map((item, index) => (
                  <Box key={index} className='booking-summary-order-content'>
                    <Typography
                      variant='body1'
                      className='booking-summary-total-label'
                    >
                      {item.label}
                    </Typography>
                    <Typography
                      variant='body1'
                      className='booking-summary-total-value'
                    >
                      {item.formattedValue}
                    </Typography>
                  </Box>
                ))}
                <Divider className='booking-summary-divider' />
                <Box
                  className='booking-summary-order-content'
                  sx={{ paddingBottom: '20px' }}
                >
                  <Typography
                    variant='h6'
                    className='booking-summary-total-label'
                  >
                    Total
                  </Typography>
                  <Typography
                    variant='h6'
                    className='booking-summary-total-value'
                  >
                    {formattedTotalAmount}
                  </Typography>
                </Box>
              </PerfectScrollbar>
            </Paper>
          </Grid>
          {(user.role === 'Admin' || user.role === 'Staff') && (
            <Grid item xs={12} md={12}>
              <Paper
                elevation={4}
                sx={{ borderRadius: '12px', padding: '10px' }}
              >
                <Box className='booking-summary-order-box'>
                  <Avatar className='booking-summary-order-avatar'>
                    <LocalOfferIcon className='booking-summary-offer' />
                  </Avatar>
                  <Typography
                    variant='h6'
                    className='booking-summary-title-style'
                  >
                    Offers
                  </Typography>
                </Box>
                <Divider className='booking-summary-divider' />

                <Box display='flex' gap={2}>
                  <Grid container spacing={4}>
                    <Grid item xs={12} sm={3} md={12} lg={4} xl={3}>
                      <Controller
                        name='applyComplementary'
                        control={control}
                        render={({ field: { onChange, ...field } }) => (
                          <FormControlLabel
                            control={
                              <Checkbox
                                {...field}
                                checked={field.value}
                                onChange={(e) => {
                                  onChange(e);
                                  updateComplementaryValue(e.target.checked);
                                }}
                              />
                            }
                            label='Apply Complementary'
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} sm={2} md={4} lg={3} xl={3}>
                      <Controller
                        name='applyDiscount'
                        control={control}
                        render={({ field: { onChange, ...field } }) => (
                          <FormControlLabel
                            control={
                              <Checkbox
                                {...field}
                                checked={field.value}
                                onChange={(e) => {
                                  onChange(e);
                                  updateDiscountValues(e.target.checked);
                                }}
                              />
                            }
                            label='Apply Discount'
                          />
                        )}
                      />
                    </Grid>
                    {showDiscount && (
                      <Grid item xs={8} sm={4} md={4} lg={3}>
                        <ControlledTextInputField
                          name={'discount'}
                          control={control}
                          rules={{
                            pattern: {
                              value: /^(100(\.00?)?|[0-9]{1,2}(\.\d{1,2})?)$/,
                              message: 'Enter a number between 0 and 100 %',
                            },
                          }}
                          size={'small'}
                          type={'number'}
                          label={'Discount %'}
                          placeholder={'Enter Discount'}
                          error={!!errors['discount']}
                          helperText={errors['discount']?.message}
                        />
                      </Grid>
                    )}

                    {showDiscount && (
                      <Grid item xs={3} sm={4} md={4} lg={2}>
                        <CustomButton
                          variant='contained'
                          className='success-button'
                          type='button'
                          onClick={() => {
                            discountedPrices();
                          }}
                          text='Apply'
                        />
                      </Grid>
                    )}
                  </Grid>
                </Box>
              </Paper>
            </Grid>
          )}

          {/* Next Button */}
          <Grid
            item
            xs={12}
            sx={{ display: 'flex', justifyContent: 'space-between' }}
            // className='button-container'
          >
            <Grid item xs={4}>
              <ControlledTextInputField
                name={'gst_number'}
                control={control}
                size={'small'}
                type={'text'}
                rules={{
                  pattern: {
                    value:
                      /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
                    message: 'Invalid GST Number format eg (27AAAPA1234A1Z5)',
                  },
                }}
                label={'GST Number'}
                placeholder={'Enter GST Number'}
                error={!!errors['gst_number']}
                helperText={errors['gst_number']?.message}
              />
            </Grid>

            <Box display='flex' gap={2}>
              <Button
                variant='contained'
                className='grey-button'
                onClick={() => {
                  let passengerDetailsRoute;

                  if (user.role === 'Admin' || user.role === 'Staff') {
                    passengerDetailsRoute = BOOKING_PASSENGER_DETAILS;
                  } else if (user.role === 'Vendor') {
                    passengerDetailsRoute = VENDOR_BOOKING_PASSENGER_DETAILS;
                  } else if (user.role === 'Customer') {
                    passengerDetailsRoute = CUSTOMER_BOOKING_PASSENGER_DETAILS;
                  }
                  navigate(passengerDetailsRoute, {
                    state: {
                      form1Value: form1Value,
                      form2Value: form2Value,
                      form3Value: formValue,
                    },
                  });
                }}
              >
                Back
              </Button>

              <CustomButton
                variant='contained'
                className='orange-button'
                onClick={submitBookingData}
                disabled={isError}
                loading={loading}
                text={formValue?.applyComplementary ? 'Complmentary' : 'Pay'}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};
export default BookingInvoice;
